import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'ld-cookies-disabled-page',
  imports: [MatIconModule, TranslocoDirective],
  templateUrl: './cookies-disabled-page.component.html',
  styleUrl: './cookies-disabled-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookiesDisabledPageComponent {
  private readonly transloco = inject(TranslocoService);

  protected onRetry(): void {
    window.location.reload();
  }

  protected getBrowserInstructions(): string {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes('chrome')) {
      return this.transloco.translate('authCookiesDisabledInstructionsChrome');
    } else if (userAgent.includes('firefox')) {
      return this.transloco.translate('authCookiesDisabledInstructionsFirefox');
    } else if (userAgent.includes('safari')) {
      return this.transloco.translate('authCookiesDisabledInstructionsSafari');
    } else if (userAgent.includes('edge')) {
      return this.transloco.translate('authCookiesDisabledInstructionsEdge');
    }

    return this.transloco.translate('authCookiesDisabledInstructionsDefault');
  }
}
